import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footerComponent" }
const _hoisted_2 = { class: "footer" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<article class=\"footer__section\"><h5 class=\"footer__title\">FIND A STORE</h5><h5 class=\"footer__title\">BECOME A MEMBER</h5><h5 class=\"footer__title\">SIGN UP FOR EMAIL</h5><h5 class=\"footer__title\">SNEAKERS CLUB MEMBERS</h5></article><article class=\"footer__section\"><h5 class=\"footer__title\">GET HELP</h5><a class=\"footer__link\">Order Status</a><a class=\"footer__link\">Delivery</a><a class=\"footer__link\">Returns</a><a class=\"footer__link\">Payments</a></article><article class=\"footer__section footer__section--mobile\"><h5 class=\"footer__title\">WE ARE SNEAKERS</h5><a class=\"footer__link\">about Sneakers</a><a class=\"footer__link\">contact</a><a class=\"footer__link\">work with us</a></article>", 3)
const _hoisted_6 = { class: "footer__section social" }
const _hoisted_7 = { class: "footer__footer" }
const _hoisted_8 = { class: "footer__gps" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "© 2023 Sneakers", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "footer__privacy" }, [
  /*#__PURE__*/_createElementVNode("a", null, "Guides"),
  /*#__PURE__*/_createElementVNode("a", null, "Cookies Policy"),
  /*#__PURE__*/_createElementVNode("a", null, "Terms of use"),
  /*#__PURE__*/_createElementVNode("a", null, "Privacy Policy")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("article", _hoisted_6, [
        _createVNode(_component_v_icon, {
          name: "la-facebook-f",
          scale: "1.1"
        }),
        _createVNode(_component_v_icon, {
          name: "bi-instagram",
          scale: "1.1"
        }),
        _createVNode(_component_v_icon, {
          name: "co-tiktok",
          scale: "1.1"
        }),
        _createVNode(_component_v_icon, {
          name: "bi-twitter",
          scale: "1.1"
        })
      ])
    ]),
    _createElementVNode("article", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", null, [
          _createVNode(_component_v_icon, { name: "md-place-sharp" }),
          _createTextVNode("Costa Rica")
        ]),
        _hoisted_9
      ]),
      _hoisted_10
    ])
  ]))
}